import React, { useState, useEffect, useRef } from "react";
import { Box, Button } from "@mui/material";
import img1 from "../ourTeam/img/aanad sir.jpg";
import img2 from "../ourTeam/img/sezal sir.jpg";
import img3 from "../ourTeam/img/pitamber.jpg";
import img4 from "../ourTeam/img/ravindr.jpg";
import img5 from "../ourTeam/img/amit.jpg";
import img6 from "../ourTeam/img/kanchan.jpg";
import img7 from "../ourTeam/img/neha.jpg";
import img8 from "../ourTeam/img/shreya tiwari.jpg";
import img9 from "../ourTeam/img/Rojalin.jpeg";
import img10 from "../ourTeam/img/Lucky.jpg";
import img11 from "../ourTeam/img/Shyamli.jpg";
import MobileCard from "./MobileCard";

const cardData = [
    {
        card_img: img1,
        card_title: "Shailendra Anand",
        card_title2: "(Founder)",
        card_description:
            "Organize, segmentand manage customer contacts to turn leads into loyal customers with ease.",
    },
    {
        card_img: img2,
        card_title: "Sazal Malhotra",
        card_title2: "(Co-Founder)",
        card_description:
            "Build powerful AI-driven chatbots with our no-code platform for seamless customer interaction.",
    },
    {
        card_img: img3,
        card_title: "Pitamber",
        card_title2: "(Saas Developer)",
        card_description:
            "Showcase your brand's authenticity and highlight your business as reliable with a verified badge.",
    },
    {
        card_img: img4,
        card_title: "Ravindra Pasvan",
        card_title2: "(Saas Developer)",
        card_description:
            "Create WhatsApp forms to gather information from customers and save time for business.",
    },
    {
        card_img: img5,
        card_title: "Amit Banjare",
        card_title2: "(Saas Developer)",
        card_description:
            "Protect customer data with secure, region-specific storage solutions for complete compliance.",
    },
    {
        card_img: img9,
        card_title: "Rojalin Behera",
        card_title2: "(Saas Developer)",
        card_description:
            "Broadcasting expands reach to a wide audience; retargeting ensures customers drive results.",
    },
    {
        card_img: img7,
        card_title: "Neha Nand",
        card_title2: "(Graphics Designer)",
        card_description:
            "Create WhatsApp forms to gather information from customers and save time for business.",
    },
    {
        card_img: img6,
        card_title: "Kanchan Adil",
        card_title2: "(Business Analyst)",
        card_description:
            "Broadcasting expands reach to a wide audience; retargeting ensures customers drive results.",
    },
    {
        card_img: img8,
        card_title: "Shreya Tiwari",
        card_title2: "(Accounted Manager)",
        card_description:
            "Broadcasting expands reach to a wide audience; retargeting ensures customers drive results.",
    },
    {
        card_img: img10,
        card_title: "Lucky",
        card_title2: "(Saas Developer)",
        card_description:
            "Broadcasting expands reach to a wide audience; retargeting ensures customers drive results.",
    },
    {
        card_img: img11,
        card_title: "Shyamli Rao",
        card_title2: "(Marketing Specialist)",
        card_description:
            "Drive impactful campaigns and boost engagement with targeted marketing strategies on WhatsApp.",
    },
];

const MobileTeamComponent = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);
    const autoSlideRef = useRef();

    // Only auto-slide to the right infinitely
    useEffect(() => {
        autoSlideRef.current = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % cardData.length);
        }, 2500);
        return () => clearInterval(autoSlideRef.current);
    }, [cardData.length]);

    // Touch handlers: allow left swipe (prev), right swipe (next)
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (touchStartX.current === null || touchEndX.current === null) return;
        const deltaX = touchStartX.current - touchEndX.current;
        if (deltaX > 50) {
            // swipe left, go next
            setCurrentIndex((prevIndex) => (prevIndex + 1) % cardData.length);
        } else if (deltaX < -50) {
            // swipe right, go prev
            setCurrentIndex(
                (prevIndex) => (prevIndex - 1 + cardData.length) % cardData.length
            );
        }
        touchStartX.current = null;
        touchEndX.current = null;
    };

    // Center the current card
    const getTranslateX = () => {
        // Each card is 75vw wide, so to center the current card:
        // Shift by: (container center) - (card center) - (index * card width)
        // container center = 50vw, card center = 37.5vw
        return `calc(50vw - 35vw - ${currentIndex * 70}vw)`;
    };

    return (
        <Box
            sx={{
                width: "100vw",
                overflow: "hidden",
                display: { xs: "block", sm: "none" },
                px: 0,
                position: "relative",
                touchAction: "pan-y",
                mt: "-8px",
            }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <Box
                sx={{
                    display: "flex",
                    transition: "transform 0.5s cubic-bezier(.4,0,.2,1)",
                    transform: `translateX(${getTranslateX()})`,
                    alignItems: "center",
                }}
            >
                {cardData.map((card, index) => {
                    // Check if card is previous or next to current
                    const isPrev =
                        index === (currentIndex - 1 + cardData.length) % cardData.length;
                    const isNext =
                        index === (currentIndex + 1) % cardData.length;
                    const isCurrent = index === currentIndex;
                    return (
                        <Box
                            key={index}
                            sx={{
                                flex: "0 0 70vw",
                                mx: "0vw",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                transform: isCurrent ? "scale(1)" : "scale(0.92)",
                                transition: "transform 0.3s, filter 0.3s",
                                zIndex: isCurrent ? 2 : 1,
                                filter:
                                    isPrev || isNext
                                        ? "blur(3px) brightness(0.95)"
                                        : isCurrent
                                            ? "none"
                                            : "blur(0.5px) brightness(0.92)",
                            }}
                        >
                            <MobileCard
                                card_img={card.card_img}
                                card_title={card.card_title}
                                card_title2={card.card_title2}
                                card_description={card.card_description}
                                index={index}
                            />
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default MobileTeamComponent;
